import React from "react";
// import React, { useState } from "react";

import COR from "../../PicesForPages/officermortgagePage.jpg";

// import MortgageCalculator from "../CalculatorAndChart/mortgageCalculator";
// import ClientReview from "../Client_Review/clientReview";
// import BlogPostInAPage from "../blogPages/BlogPagePosts/blogPostInAPage";
// import FreeQuoteForm from "../Form/FreeQuote";

import blankPhoto from "../../PicesForPages/blank.jpg";
import Kumar_Sista from "../../PicesForPages/Kumar_Sista_Team.png";
import Apeksha_Sista from "../../PicesForPages/Apeksha_Sista_Team.png";
// import Vishwas_Batheja from "../../PicesForPages/Vishwas_Batheja_Team.png";
import Vamsi_Krishna_Tummala from "../../PicesForPages/Vamsi_Krishna_Tummala_Team.png";
import Kousalya_Tummala from "../../PicesForPages/Kousalya_Tummala_Team.png";
import Sista_Kamesh from "../../PicesForPages/SistaKamesh_Team.png";
import Bhanu_Chennubhotla from "../../PicesForPages/Bhanu_Chennubhotla_Team.png";
import Maharshi_Patel from "../../PicesForPages/Maharshi_Patel.png";
import Raghuram_Mylavarapu from "../../PicesForPages/Raghuram_Mylavarapu.png";
import Sanjeeva_Pidugu from "../../PicesForPages/Sanjeeva_Pidugu_Team.png";
import Kalyan_Patibandla from "../../PicesForPages/Kalyan_Patibandla_Team.png";

import { useParams } from "react-router-dom";

function TeamMemberFullDetails() {
  const { id } = useParams();

  // Initialize the state before any condition
  // const [isFreeQuoteVisible, setIsFreeQuoteVisible] = useState(false);

  const teamMembers = {
    "apeksha-sista": {
      name: "Apeksha Sista",
      role: "Loan Originator",
      photo: Apeksha_Sista,
      nmls: "2692605",
      address: "134 John Robert Thomas Dr, \n2nd Floor, Exton, PA 19341",
      contactPhone: "(610) 836-2332",
      contactMail: "Apeksha.Sista@TheMortgageist.com",
      yourService: `Apeksha Sista is a dedicated Mortgage Loan Officer committed to guiding you through the intricate world of home financing. With a focus on personalized service, Apeksha works tirelessly to understand your unique financial goals and design tailored solutions that meet your needs. Her exceptional professionalism, clarity, and attention to detail ensure every client receives transparent guidance from application to closing. Known for building trustworthy relationships, Apeksha empowers you to make informed decisions with confidence.\n\nDon't wait—take action today and connect with Apeksha Sista to begin your journey toward securing the best mortgage options for your future.`,
    },
    "kumar-sista": {
      name: "Kumar Sista",
      role: "Loan Originator",
      photo: Kumar_Sista,
      nmls: "2369551",
      address: "134 John Robert Thomas Dr, \n2nd Floor, Exton, PA 19341",
      contactPhone: "(610) 618-0618",
      contactMail: "Kumar.Sista@TheMortgageist.com",
      yourService: `Kumar Sista is a distinguished Mortgage Loan Officer with multiple years of experience in the mortgage industry and recognized as the number one loan officer in Pennsylvania. His deep industry expertise and proven track record empower him to guide you seamlessly through every step of the mortgage process. Kumar tailors financing solutions to meet your unique financial needs while providing exceptional professionalism, clarity, and attention to detail.\n\nDon't delay—take action now! Contact Kumar Sista today to begin your journey toward homeownership and unlock the potential of the loan that fits your future.\n\nHe is Your Very Own Loan Officer.`,
    },
    "kiran-g": {
      name: "Kiran G",
      role: "Loan Originator",
      photo: blankPhoto,
      nmls: "2525597",
      address: "134 John Robert Thomas Dr, \n2nd Floor, Exton, PA 19341",
      contactPhone: "(469) 863-1636",
      contactMail: "Kiran.G@TheMortgageist.com",
      yourService: `I am dedicated to helping individuals and families achieve their homeownership goals. My focus is on making the mortgage process simple, transparent, and tailored to your unique financial needs.\n\nWhether you’re purchasing your first home, refinancing, or investing in property, I’ll guide you through every step with clear communication and personalized solutions. By combining industry expertise with modern technology, I streamline applications and ensure timely results, so you can focus on what matters most, finding the right home.\n\nI believe in building lasting relationships based on trust and honesty. My goal is to provide guidance and support that empowers you to make confident decisions today and in the future.\n\n\nReady to get started? Let’s connect!`,
    },
    "vamsi-tummala": {
      name: "Vamsi Tummala",
      role: "Loan Originator",
      photo: Vamsi_Krishna_Tummala,
      nmls: "2587554",
      address: "134 John Robert Thomas Dr, \n2nd Floor, Exton, PA 19341",
      contactPhone: "(484) 682-7290",
      contactMail: "Vamsi.Tummala@TheMortgageist.com",
      yourService: `      With a passion for helping families achieve their homeownership dreams, Vamsi Tummala brings years of experience and a client-first approach to every mortgage journey. As a trusted Mortgage Loan Originator at The Mortgageist Inc, Vamsi specializes in guiding homebuyers and homeowners through the lending process with clarity, care, and confidence.\n\nWhether you're a first-time buyer, refinancing your current home, or investing in property, Vamsi offers tailored solutions backed by deep industry knowledge and a commitment to transparency. His personalized service, quick responsiveness, and ability to simplify complex financial decisions have earned him the trust of clients and real estate partners alike.\n\nVamsi believes that every client deserves a smooth, stress-free mortgage experience—and he works tirelessly to deliver just that. From pre-approval to closing, he's by your side every step of the way.\n\nLet's make your homeownership goals a reality.`,
    },
    "kousalya-tummala": {
      name: "Kousalya Tummala",
      role: "Loan Originator",
      photo: Kousalya_Tummala,
      nmls: "2587557",
      address: "134 John Robert Thomas Dr, \n2nd Floor, Exton, PA 19341",
      contactPhone: "(908) 248-1544",
      contactMail: "Kousalya.Tummala@TheMortgageist.com",
      yourService: `Kousalya Tummala is a trusted Senior Mortgage Loan Originator at The Mortgageist, dedicated to helping clients make informed, confident decisions about home financing. With extensive experience in the mortgage industry, Kousalya brings a deep understanding of loan products, market trends, and personalized financial strategies to every client interaction.\n\nWhether you're buying your first home, refinancing, or building your dream property, Kousalya is committed to delivering expert guidance and exceptional service. Her approach is rooted in transparency, responsiveness, and a genuine desire to help families achieve their homeownership goals with ease.\n\nClients appreciate her ability to simplify the mortgage process, offer tailored solutions, and provide timely advice that aligns with their financial needs. Kousalya's professionalism and warmth make her a reliable partner throughout the entire loan journey—from application to closing.\n\nLet's make your homeownership journey smooth and successful.`,
    },
    "vai-sista": {
      name: "Vai Sista",
      role: "Loan Originator",
      photo: Sista_Kamesh,
      nmls: "2719500",
      address: "134 John Robert Thomas Dr, \n2nd Floor, Exton, PA 19341",
      contactPhone: "(609) 721-5168",
      contactMail: "LoansByVai@TheMortgageist.com",
      yourService: `Vai Sista is a trusted Senior Mortgage Loan Originator at The Mortgageist, dedicated to helping clients make informed, confident decisions about home financing. With extensive experience in the mortgage industry, Vai Sista brings a deep understanding of loan products, market trends, and personalized financial strategies to every client interaction.\n\nWhether you're buying your first home, refinancing, or building your dream property, Vai Sista is committed to delivering expert guidance and exceptional service. Her approach is rooted in transparency, responsiveness, and a genuine desire to help families achieve their homeownership goals with ease.\n\nClients appreciate her ability to simplify the mortgage process, offer tailored solutions, and provide timely advice that aligns with their financial needs. Vai Sista's professionalism and warmth make her a reliable partner throughout the entire loan journey—from application to closing.\n\nLet's make your homeownership journey smooth and successful.`,
    },
    "bhanu-chennubhotla": {
      name: "Bhanu Chennubhotla",
      role: "Loan Originator",
      photo: Bhanu_Chennubhotla,
      nmls: "2497400",
      address: "134 John Robert Thomas Dr, \n2nd Floor, Exton, PA 19341",
      contactPhone: "(860) 389-8767",
      contactMail: "bhanuc@themortgageist.com",
      yourService: `Bhanu Chennubhotla is a dedicated Mortgage Loan Officer committed to guiding you through the intricate world of home financing. With a focus on personalized service, Bhanu works tirelessly to understand your unique financial goals and design tailored solutions that meet your needs. Her exceptional professionalism, clarity, and attention to detail ensure every client receives transparent guidance from application to closing. Known for building trustworthy relationships, Bhanu empowers you to make informed decisions with confidence.\n\nDon't wait—take action today and connect with Bhanu to begin your journey toward securing the best mortgage options for your future.`,
    },
    "maharshi-patel": {
      name: "Maharshi Patel",
      role: "Loan Originator",
      photo: Maharshi_Patel,
      nmls: "2781812",
      address: "134 John Robert Thomas Dr, \n2nd Floor, Exton, PA 19341",
      contactPhone: "(215) 219-5604",
      contactMail: "Rishi.Patel@TheMortgageist.com",
      yourService: `Maharshi Patel is a dedicated Mortgage Loan Officer committed to guiding you through the intricate world of home financing. With a focus on personalized service, Maharshi works tirelessly to understand your unique financial goals and design tailored solutions that meet your needs. Her exceptional professionalism, clarity, and attention to detail ensure every client receives transparent guidance from application to closing. Known for building trustworthy relationships, Maharshi empowers you to make informed decisions with confidence.\n\nDon't wait—take action today and connect with Maharshi to begin your journey toward securing the best mortgage options for your future.`,
    },
    "raghuram-mylavarapu": {
      name: "Raghuram Mylavarapu",
      role: "Loan Originator",
      photo: Raghuram_Mylavarapu,
      nmls: "2620091",
      address: "134 John Robert Thomas Dr, \n2nd Floor, Exton, PA 19341",
      contactPhone: "(302) 898-5552",
      contactMail: "RaghuM@TheMortgageist.Com",
      yourService: `Driven by a deep commitment to delivering exceptional customer experiences, I bring a strong blend of data-driven insight, personalized guidance, and trusted partnership to every mortgage journey. With over 30 years of leadership experience in IT and client-facing roles, I’ve consistently championed initiatives that create meaningful outcomes for customers, simplifying complexity, improving transparency, and ensuring every client feels confident and informed throughout the lending process.\n\nMy approach combines empathy, clear communication, and disciplined execution. I translate financial goals into simple, actionable steps and work closely with clients to help them navigate every stage of the mortgage process with clarity and confidence. I take pride in building strong relationships, fostering trust, and ensuring a smooth, compliant, and stress-free experience from application to closing.\n\nUltimately, my mission is to make home lending a transparent and empowering process, turning one of life’s biggest decisions into a seamless and positive milestone.`,
    },
    "sanjeeva-pidugu": {
      name: "Sanjeeva Pidugu",
      role: "Loan Originator",
      photo: Sanjeeva_Pidugu,
      nmls: "2776226",
      address: "134 John Robert Thomas Dr, \n2nd Floor, Exton, PA 19341",
      contactPhone: "(216) 533-0753",
      contactMail: "Sanjeeva.Pidugu@themortgageist.com",
      yourService: `With over 16 years of experience in Investment Banking IT, I’ve built my career on precision, data integrity, and navigating complex financial systems where details matter and mistakes aren’t an option. I bring that same zero‑error mindset to my work as a Mortgage Loan Originator, helping families move through the home‑financing process with clarity and confidence.\n\nI understand that no two financial situations are alike, which is why I don’t believe in cookie‑cutter loans. Whether you’re purchasing your first home, upgrading for a growing family, or exploring a refinance, I focus on understanding your goals and delivering customized mortgage solutions that support both your current needs and long‑term plans.\n\nMore than a Loan Officer, I am your trusted financial partner, someone you can rely on for transparency, strategy, and steady support. My mission is simple: to help build lasting financial stability, one home at a time.`,
    },
    "kalyan-patibandla": {
      name: "Kalyan Patibandla",
      role: "Loan Originator",
      photo: Kalyan_Patibandla,
      nmls: "2787855",
      address: "134 John Robert Thomas Dr, \n2nd Floor, Exton, PA 19341",
      contactPhone: "(469) 432-1548",
      contactMail: "Kalyan.Patibandla@TheMortgageist.com",
      yourService: `Kalyan Patibandla is a Mortgage Loan Officer dedicated to helping clients achieve home ownership with confidence and ease. He focuses on clear communication, personalized solutions, and delivering a smooth lending experience for every borrower. Kalyan works with both first-time home buyers and seasoned investors, ensuring each client understands their options and feels supported throughout the process.\n\nOutside of his professional responsibilities, he enjoys following financial markets, including stocks, as well as motorcycling and maintaining an active fitness lifestyle. He values continuous learning, personal growth, and spending quality time with family and friends, bringing balance and a positive mindset to both his professional and personal life.`,
    },
  };

  const member = teamMembers[id];

  if (!member) {
    return <div>Team Member not found</div>;
  }

  // // Function to hide the FreeQuoteFormParent
  // const hideFreeQuoteForm = () => {
  //   setIsFreeQuoteVisible(false);
  // };

  // // Function to handle clicks outside the FreeQuoteBox
  // const handleOutsideClick = (event) => {
  //   if (event.target.classList.contains("FreeQuoteFormParent")) {
  //     hideFreeQuoteForm();
  //   }
  // };

  return (
    <div className="purchaseParent ourTeamMemberParent">
      <div className="ourTeamMemberTopParent">
        <img
          fetchPriority="high"
          loading="eager"
          src={COR}
          alt="CORImage"
          className="ourTeamMemberTopBGImage"
        />
        <div className="ourTeamMemberTopBox">
          <span className="ourTeamMemberTopLeftSide">
            <span className="ourTeamMemberTopLeftSideSpanImage">
              <img
                fetchPriority="high"
                loading="eager"
                src={member.photo}
                alt={member.name}
                className="ourTeamMemberTopStaffImage"
              />
            </span>
            <span>
              <span className="ourTeamMemberTopLeftSideName">
                {member.name}
              </span>
              <br />
              <span className="ourTeamMemberTopLeftSideRole">
                {member.role}
              </span>
              <br />
              <span className="ourTeamMemberTopLeftSideNMLS">
                NMLS#: {member.nmls}
              </span>
              <br />
            </span>
          </span>
          <span className="ourTeamMemberTopRightSide">
            <span>
              <b>Address:</b>
              <br />
              {member.address.split("\n").map((line, index) => (
                <React.Fragment key={index}>
                  {line}
                  <br />
                </React.Fragment>
              ))}
            </span>
            <br />
            <span>
              <b>Contact:</b>
              <br />
              <i className="ri-phone-fill"></i> {member.contactPhone}
              <br />
              <i className="ri-mail-send-fill"></i> {member.contactMail}
              <br />
            </span>
          </span>
        </div>
      </div>
      <div className="purchaseBottomParent ourTeamMemberBottomParent">
        <div className="purchaseBottomBox">
          <div className="purchaseBottomLeftBox">
            {/* <div className="purchaseBottomLeftButton">
              <a
                href="https://themortgageist.my1003app.com/2692605/register/"
                target="_blank"
                rel="noreferrer"
                className="purchaseBottomLeftButtonLink"
              >
                Apply Now
              </a>
              <span
                className="purchaseBottomLeftButtonLink00"
                onClick={(e) => {
                  e.preventDefault();
                  setIsFreeQuoteVisible(true);
                }}
              >
                Free Quote
              </span>
            </div> */}

            <span className="purchaseBottomLeftHeader">At Your Service</span>

            <span className="purchaseBottomLeftContent">
              {member.yourService.split("\n").map((line, index) => (
                <React.Fragment key={index}>
                  {line}
                  <br />
                </React.Fragment>
              ))}
            </span>
          </div>
        </div>
      </div>
      {/* <ClientReview /> */}
      {/* <MortgageCalculator /> */}
      {/* <BlogPostInAPage /> */}
      {/* <div className="addressBoxParent">
        <div className="addressBox">
          <div className="addressHeading">
            <span className="logoBoldColor">The Mortgageist</span> Address
          </div>
          <div className="addressMapDetails">
            <iframe
              title="The Mortgageist Office Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3055.148352419005!2d-75.64042789999999!3d40.027467099999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c6f48cf873943f%3A0xca16a916a828a09!2s134%20John%20Robert%20Thomas%20Dr%2C%20Exton%2C%20PA%2019341%2C%20USA!5e0!3m2!1sen!2sin!4v1769504624665!5m2!1sen!2sin"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div> */}
      {/* {isFreeQuoteVisible && (
        <div className="FreeQuoteFormParent" onClick={handleOutsideClick}>
          <div className="FreeQuoteFormBox">
            <FreeQuoteForm officerName={`${member.name} ${member.nmls}`} />
            <span
              className="FreeQuoteFormCloseButton"
              onClick={hideFreeQuoteForm}
            >
              <span>X</span>
            </span>
          </div>
        </div>
      )} */}
    </div>
  );
}

export default TeamMemberFullDetails;
